import { InputText, TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Box, Button, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ProfileAccess = () => {
  const { t } = useTranslation();
  const { hostname } = new URL(window.location.href);

  const getUrl = () => {
    switch (true) {
      case hostname.includes('demo.practitioner.insights.com'):
        return 'https://demo.experience.insights.com';
      case hostname.includes('review.insights.com'):
        return 'https://test.experience.insights.com';
      case hostname.includes('test.practitioner.insights.com'):
        return 'https://test.experience.insights.com';
      case hostname === 'localhost':
        return 'http://localhost:3000/';
      default:
        return 'https://experience.insights.com';
    }
  };

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[500]}`,
        marginTop: theme.spacing(spacingSizeMap.S),
        padding: theme.spacing(spacingSizeMap.S),
        borderRadius: '4px',
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.25),
      })}
    >
      <TextV2 variant="h4">
        {t(
          'ui.event-management.dashboard.digital-profile-activation-link.title',
        )}
      </TextV2>
      <TextV2 component="p">
        {t(
          'ui.event-management.dashboard.digital-profile-activation-link.desc',
        )}
      </TextV2>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '720px',
          gap: 1,
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            padding: '0 !important',
            float: 'left',
            maxWidth: '720px',
          }}
        >
          <InputText
            disabled
            id="profile-access-disabled-input"
            value={getUrl()}
            fullWidth
          />
        </Container>
        <Button
          data-testid="profile-access-copy"
          variant="outlined"
          onClick={() => {
            navigator.clipboard.writeText(getUrl());
          }}
        >
          {t(
            'ui.event-management.dashboard.digital-profile-activation-link.copy-button',
          )}
        </Button>
      </Box>
    </Box>
  );
};
